export enum ICON_NAMES {
  academicCap = 'academic-cap',
  adjustments = 'adjustments',
  annotation = 'annotation',
  archive = 'archive',
  arrowCircleDown = 'arrow-circle-down',
  arrowCircleLeft = 'arrow-circle-left',
  arrowCircleRight = 'arrow-circle-right',
  arrowCircleUp = 'arrow-circle-up',
  arrowDown = 'arrow-down',
  arrowLeft = 'arrow-left',
  arrowNarrowDown = 'arrow-narrow-down',
  arrowNarrowLeft = 'arrow-narrow-left',
  arrowNarrowRight = 'arrow-narrow-right',
  arrowNarrowUp = 'arrow-narrow-up',
  arrowRight = 'arrow-right',
  arrowSmDown = 'arrow-sm-down',
  arrowSmLeft = 'arrow-sm-left',
  arrowSmRight = 'arrow-sm-right',
  arrowSmUp = 'arrow-sm-up',
  arrowUp = 'arrow-up',
  arrowsExpand = 'arrows-expand',
  atSymbol = 'at-symbol',
  backspace = 'backspace',
  badgeCheck = 'badge-check',
  ban = 'ban',
  beaker = 'beaker',
  bell = 'bell',
  bookOpen = 'book-open',
  bookmarkAlt = 'bookmark-alt',
  bookmark = 'bookmark',
  briefcase = 'briefcase',
  cake = 'cake',
  calculator = 'calculator',
  calendar = 'calendar',
  camera = 'camera',
  cash = 'cash',
  chartBar = 'chart-bar',
  chartPie = 'chart-pie',
  chartSquareBar = 'chart-square-bar',
  chatAlt2 = 'chat-alt-2',
  chatAlt = 'chat-alt',
  chat = 'chat',
  checkCircle = 'check-circle',
  check = 'check',
  chevronDoubleDown = 'chevron-double-down',
  chevronDoubleLeft = 'chevron-double-left',
  chevronDoubleRight = 'chevron-double-right',
  chevronDoubleUp = 'chevron-double-up',
  chevronDown = 'chevron-down',
  chevronLeft = 'chevron-left',
  chevronRight = 'chevron-right',
  chevronUp = 'chevron-up',
  chip = 'chip',
  clipboardCheck = 'clipboard-check',
  clipboardCopy = 'clipboard-copy',
  clipboardList = 'clipboard-list',
  clipboard = 'clipboard',
  clock = 'clock',
  cloudDownload = 'cloud-download',
  cloudUpload = 'cloud-upload',
  cloud = 'cloud',
  code = 'code',
  cog = 'cog',
  collection = 'collection',
  colorSwatch = 'color-swatch',
  creditCard = 'credit-card',
  cubeTransparent = 'cube-transparent',
  cube = 'cube',
  currencyBangladeshi = 'currency-bangladeshi',
  currencyDollar = 'currency-dollar',
  currencyEuro = 'currency-euro',
  currencyPound = 'currency-pound',
  currencyRupee = 'currency-rupee',
  currencyYen = 'currency-yen',
  cursorClick = 'cursor-click',
  database = 'database',
  desktopComputer = 'desktop-computer',
  deviceMobile = 'device-mobile',
  deviceTablet = 'device-tablet',
  documentAdd = 'document-add',
  documentDownload = 'document-download',
  documentDuplicate = 'document-duplicate',
  documentRemove = 'document-remove',
  documentReport = 'document-report',
  documentSearch = 'document-search',
  documentText = 'document-text',
  document = 'document',
  dotsCircleHorizontal = 'dots-circle-horizontal',
  dotsHorizontal = 'dots-horizontal',
  dotsVertical = 'dots-vertical',
  download = 'download',
  duplicate = 'duplicate',
  emojiHappy = 'emoji-happy',
  emojiSad = 'emoji-sad',
  exclamationCircle = 'exclamation-circle',
  exclamation = 'exclamation',
  externalLink = 'external-link',
  eyeOff = 'eye-off',
  eye = 'eye',
  fastForward = 'fast-forward',
  film = 'film',
  filter = 'filter',
  fingerPrint = 'finger-print',
  fire = 'fire',
  flag = 'flag',
  folderAdd = 'folder-add',
  folderDownload = 'folder-download',
  folderOpen = 'folder-open',
  folderRemove = 'folder-remove',
  folder = 'folder',
  gift = 'gift',
  globeAlt = 'globe-alt',
  globe = 'globe',
  hand = 'hand',
  hashtag = 'hashtag',
  heart = 'heart',
  home = 'home',
  identification = 'identification',
  inboxIn = 'inbox-in',
  inbox = 'inbox',
  informationCircle = 'information-circle',
  key = 'key',
  library = 'library',
  lightBulb = 'light-bulb',
  lightningBolt = 'lightning-bolt',
  link = 'link',
  locationMarker = 'location-marker',
  lockClosed = 'lock-closed',
  lockOpen = 'lock-open',
  login = 'login',
  logout = 'logout',
  mailOpen = 'mail-open',
  mail = 'mail',
  map = 'map',
  menuAlt1 = 'menu-alt-1',
  menuAlt2 = 'menu-alt-2',
  menuAlt3 = 'menu-alt-3',
  menuAlt4 = 'menu-alt-4',
  menu = 'menu',
  microphone = 'microphone',
  minusCircle = 'minus-circle',
  minusSm = 'minus-sm',
  minus = 'minus',
  moon = 'moon',
  musicNote = 'music-note',
  newspaper = 'newspaper',
  officeBuilding = 'office-building',
  paperAirplane = 'paper-airplane',
  paperClip = 'paper-clip',
  pause = 'pause',
  pencilAlt = 'pencil-alt',
  pencil = 'pencil',
  phoneIncoming = 'phone-incoming',
  phoneMissedCall = 'phone-missed-call',
  phoneOutgoing = 'phone-outgoing',
  phone = 'phone',
  photograph = 'photograph',
  play = 'play',
  plusCircle = 'plus-circle',
  plusSm = 'plus-sm',
  plus = 'plus',
  presentationChartBar = 'presentation-chart-bar',
  presentationChartLine = 'presentation-chart-line',
  printer = 'printer',
  puzzle = 'puzzle',
  qrcode = 'qrcode',
  questionMarkCircle = 'question-mark-circle',
  receiptRefund = 'receipt-refund',
  receiptTax = 'receipt-tax',
  refresh = 'refresh',
  reply = 'reply',
  rewind = 'rewind',
  rss = 'rss',
  saveAs = 'save-as',
  save = 'save',
  scale = 'scale',
  scissors = 'scissors',
  searchCircle = 'search-circle',
  search = 'search',
  selector = 'selector',
  server = 'server',
  share = 'share',
  shieldCheck = 'shield-check',
  shieldExclamation = 'shield-exclamation',
  shoppingBag = 'shopping-bag',
  shoppingCart = 'shopping-cart',
  sortAscending = 'sort-ascending',
  sortDescending = 'sort-descending',
  sparkles = 'sparkles',
  speakerphone = 'speakerphone',
  star = 'star',
  statusOffline = 'status-offline',
  statusOnline = 'status-online',
  stop = 'stop',
  sun = 'sun',
  support = 'support',
  switchHorizontal = 'switch-horizontal',
  switchVertical = 'switch-vertical',
  table = 'table',
  tag = 'tag',
  template = 'template',
  terminal = 'terminal',
  thumbDown = 'thumb-down',
  thumbUp = 'thumb-up',
  ticket = 'ticket',
  translate = 'translate',
  trash = 'trash',
  trendingDown = 'trending-down',
  trendingUp = 'trending-up',
  truck = 'truck',
  upload = 'upload',
  userAdd = 'user-add',
  userCircle = 'user-circle',
  userGroup = 'user-group',
  userRemove = 'user-remove',
  user = 'user',
  users = 'users',
  variable = 'variable',
  videoCamera = 'video-camera',
  viewBoards = 'view-boards',
  viewGridAdd = 'view-grid-add',
  viewGrid = 'view-grid',
  viewList = 'view-list',
  volumeOff = 'volume-off',
  volumeUp = 'volume-up',
  wifi = 'wifi',
  xCircle = 'x-circle',
  x = 'x',
  zoomIn = 'zoom-in',
  zoomOut = 'zoom-out',

  reCaptcha = 'recaptcha',

  providerCivic = 'civic',
  providerGitCoin = 'gitcoin',
  providerUnstoppable = 'unstoppable',
  providerWorldCoin = 'worldcoin',

  metamask = 'metamask',

  polygon = 'polygon',
  ethereum = 'ethereum',
  arbitrum = 'arbitrum',
  avalanche = 'avalanche',

  usersGroup4 = 'users-group-4',
  robot = 'robot',

  credentialsLoader = 'credentials-loader',
}
